import React from "react";
import { Lock, Check } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { setCosmetics } from "@/lib/cosmetics";

const Swatch = ({ p }) => (
  <span className="flex items-end gap-0.5 rounded-md px-2 py-1.5 border" style={{ background: p.bg, borderColor: p.border }}>
    {[p.up, p.down, p.up, p.up, p.down].map((c, i) => (
      <span key={i} style={{ background: c, width: 5, height: [10, 14, 8, 16, 12][i] }} className="rounded-[1px]" />
    ))}
    <span style={{ background: p.vwap, width: 10, height: 2 }} className="ml-1 mb-1.5" />
  </span>
);

export const ThemePicker = ({ state }) => {
  const pick = async (key) => {
    try { const r = await api.post("/cosmetics/theme", { key }); setCosmetics(r.data); toast.success("Chart theme saved."); }
    catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <section className="tc-card p-5 space-y-3" data-testid="theme-picker">
      <div>
        <h2 className="font-heading font-bold">Chart appearance</h2>
        <p className="text-xs text-tc-muted">Colours for every chart in the app. Looks only: no price, indicator or score changes. Saved to your account.</p>
      </div>
      <div className="grid gap-2 sm:grid-cols-2">
        {state.themes.map((t) => (
          <button key={t.key} data-testid={`theme-option-${t.key}`} disabled={!t.unlocked} onClick={() => pick(t.key)}
            className={`rounded-lg border px-3 py-2 text-left text-sm flex items-center gap-3 transition-colors disabled:cursor-not-allowed ${state.chart_theme === t.key ? "border-tc-coach/60 bg-tc-coach/10" : "border-white/10 hover:border-white/30 disabled:hover:border-white/10"}`}>
            <span className={t.unlocked ? "" : "opacity-40"}><Swatch p={t.palette} /></span>
            <span className="flex-1 min-w-0">
              <span className="block font-medium">{t.name}</span>
              <span className="block text-[11px] text-tc-muted">{t.unlocked ? "Unlocked" : `Unlocks at Level ${t.unlock_level}`}</span>
            </span>
            {state.chart_theme === t.key ? <Check className="w-4 h-4 text-tc-coach shrink-0" />
              : !t.unlocked ? <Lock className="w-4 h-4 text-tc-muted shrink-0" data-testid={`theme-locked-${t.key}`} /> : null}
          </button>
        ))}
      </div>
    </section>
  );
};
